import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { wrapper } from './wrapper-helper';
import { CurrentFileBlob, XlsxFile, RangeSelection } from './UpdateReferenceData';
import { ReferenceDataValue } from 'entities/document';

type SheetOption = { value: number; label: string };

interface SelectSheetProps {
  file: { isLoading: boolean; isSuccess: boolean };
  maybeFile?: XlsxFile;
  sheetOptions?: SheetOption[];
  currentReferenceData: ReferenceDataValue;
  onNewFileClick: () => void;
  onSelectSheet: (label: string) => void;
  notice?: ReactNode;
}

export function SelectSheet(props: SelectSheetProps) {
  const { t } = useTranslation('reference-data');

  const { file, maybeFile, sheetOptions, currentReferenceData, onNewFileClick, onSelectSheet, notice = null } = props;

  return wrapper(
    t('update-sheet.modal.title'),
    [file],
    () => (
      <div>
        <CurrentFileBlob file={maybeFile}>
          <div onClick={onNewFileClick}>{t('update-sheet.link.choose-new-file')}</div>
        </CurrentFileBlob>
        <table>
          <tbody>
            {sheetOptions?.map((option) => (
              <tr key={option.label} onClick={() => onSelectSheet(option.label)}>
                {option.label === (currentReferenceData.selection as RangeSelection | undefined)?.sheet ? (
                  <td>
                    <span className="fs-6 text-blue-800">
                      <i className="fa-regular fa-link"></i> {option.label}
                    </span>
                    <br />
                    <span className="text-gray-700">{t('update-sheet.current-sheet')}</span>
                  </td>
                ) : (
                  <td>{option.label}</td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ),
    () => <></>,
    notice
  );
}
